<div class="container" tid="home-plugin-page">
    <tam-toast [isAddInMode]="getAddInMode"></tam-toast>
    <router-outlet></router-outlet>
    <note-dialog></note-dialog>
    <calendar-dialog></calendar-dialog>
    <entity-dialog [id]="instanceId"></entity-dialog>
    <tam-duplicated-contact-dialog></tam-duplicated-contact-dialog>
    <contact-dialog [id]="instanceId"></contact-dialog>
    <ng-template #flyContainer></ng-template>
    <app-alert-window></app-alert-window>
    <tam-note-attachments-buffer></tam-note-attachments-buffer>
    <tam-pdffile-preview [config]='filePreviewConfig'></tam-pdffile-preview>
</div>